import { useState, useEffect } from 'react';
import { Domain } from '@/types/domain';
import { domainService } from '@/services/domainService';

export const useDomain = () => {
  const [domain, setDomain] = useState<Domain | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDomain = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // Get hostname from window.location
        const hostname = window.location.hostname;
        
        // Fetch domain by hostname
        const domainData = await domainService.getDomainByHostname(hostname);
        setDomain(domainData);
      } catch (err) {
        console.error('Error fetching domain:', err);
        setError('Failed to load domain information');
      } finally {
        setIsLoading(false);
      }
    };

    fetchDomain();
  }, []);

  return { domain, isLoading, error };
}; 